(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vx-1k-system"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.getAttribute('data-vx-ready')) return;
    root.setAttribute('data-vx-ready','1');
    var data={};
    try{ data=JSON.parse(root.querySelector('[data-vx-sys-data]').textContent); }catch(e){ return; }
    var T=data.t||{}, cur=root.getAttribute('data-currency')||'HUF', loc=root.getAttribute('data-locale')||'hu';
    var nloc=loc==='en'?'en-GB':(loc==='de'?'de-DE':'hu-HU');
    var q=function(s){ return root.querySelector(s); };
    var area=q('[data-vx-area]'), range=q('[data-vx-range]'), msg=q('[data-vx-msg]'), total=q('[data-vx-total]');
    var btn=q('[data-vx-add]'), status=q('[data-vx-status]'), coatName=q('[data-vx-coatname]'), extra=q('[data-vx-extra]');
    var uses=Array.prototype.slice.call(root.querySelectorAll('[data-vx-use]'));
    var emptyMsg=msg?msg.textContent:'', emptyBtn=btn?btn.textContent:'';
    var rows={};
    ['main','primer','coat'].forEach(function(k){ var r=q('[data-vx-row="'+k+'"]'); rows[k]={el:r, detail:r&&r.querySelector('[data-vx-detail]'), price:r&&r.querySelector('[data-vx-price]')}; });
    var plan=null;
    function fmt(n,d){ return n.toLocaleString(nloc,{minimumFractionDigits:d,maximumFractionDigits:d}); }
    function money(c){
      try{ if(window.theme&&theme.Currency&&typeof theme.Currency.formatMoney==='function'&&theme.settings&&theme.settings.moneyFormat) return theme.Currency.formatMoney(Math.round(c),theme.settings.moneyFormat); }catch(e){}
      try{ return new Intl.NumberFormat(nloc,{style:'currency',currency:cur,maximumFractionDigits:cur==='HUF'?0:2}).format(c/100); }catch(e){ return fmt(c/100,0)+' '+cur; }
    }
    function packs(list){ return (list||[]).map(function(v){ return {id:v.id, kg:parseFloat(String(v.t).replace(',', '.')), price:v.p, a:v.a}; }).filter(function(v){ return v.kg>0; }).sort(function(x,y){ return y.kg-x.kg; }); }
    function best(need, list){
      var av=list.filter(function(p){ return p.a; });
      if(!av.length) return null;
      var top=null;
      (function rec(i,rem,chosen,cost,count){
        var p=av[i];
        if(i===av.length-1){
          var k=rem>1e-9?Math.ceil(rem/p.kg-1e-9):0, c=cost+k*p.price, n=count+k;
          if(!top||c<top.cost||(c===top.cost&&n<top.count)) top={cost:c,count:n,items:k?chosen.concat([{p:p,q:k}]):chosen};
          return;
        }
        for(var k=Math.ceil(rem/p.kg-1e-9);k>=0;k--) rec(i+1,Math.max(0,rem-k*p.kg),k?chosen.concat([{p:p,q:k}]):chosen,cost+k*p.price,count+k);
      })(0,need,[],0,0);
      return top;
    }
    function kgTxt(kg){ var d=kg<1?2:1, f10=Math.pow(10,d), r=Math.round(kg*f10)/f10, dd=(Math.round(r*f10)%f10===0)?0:((d===2&&Math.round(r*f10)%10===0)?1:d); return T.approx+' '+fmt(r,dd)+' kg'; }
    function comboTxt(c){ return c.items.map(function(it){ return it.q+' × '+fmt(it.p.kg,it.p.kg%1?1:0)+' kg'; }).join(' + '); }
    function num(el){ if(!el) return 0; var v=parseFloat((el.value||'').replace(',', '.').replace(/[^0-9.]/g,'')); return isNaN(v)?0:v; }
    function activeUse(){ var b=uses.filter(function(u){ return u.getAttribute('aria-pressed')==='true'; })[0]||uses[0]; return b; }
    function setMsg(t,cls){ if(!msg) return; msg.textContent=t; msg.classList.remove('is-error','is-info'); if(cls) msg.classList.add(cls); }
    function reset(){
      plan=null;
      Object.keys(rows).forEach(function(k){ if(rows[k].el){ rows[k].el.classList.remove('is-na'); rows[k].detail.textContent='–'; rows[k].price.textContent='–'; } });
      total.textContent='–'; btn.disabled=true; btn.textContent=emptyBtn; status.textContent='';
    }
    function update(fromRange){
      var a=num(area);
      if(!fromRange&&range&&a>0) range.value=String(Math.min(200,Math.max(1,a)));
      if(!(a>0)){ reset(); setMsg(emptyMsg); return; }
      var u=activeUse(); if(!u){ reset(); return; }
      var cov=parseFloat(String(u.getAttribute('data-cov')||'').replace(',', '.'))||0, pro=u.getAttribute('data-pro')==='1';
      var A=a*(extra&&extra.checked?1.1:1);
      var lines=[], sum=0, missing=[];
      // kőszőnyeg: vödrönkénti fedés alapján (m² ÷ m²/vödör, felfelé kerekítve)
      var m=data.main, bucket=data.bucket||25, nB=cov>0?Math.max(1,Math.ceil(A/cov-1e-9)):0;
      var sub=u.querySelector('span'); sub=sub?sub.textContent:'';
      rows.main.detail.textContent=nB+' × '+bucket+' kg'+(sub?' · '+sub:'');
      if(m&&m.a){ rows.main.el.classList.remove('is-na'); rows.main.price.textContent=money(nB*m.price); sum+=nB*m.price; lines.push({id:m.id,quantity:nB}); }
      else { rows.main.el.classList.add('is-na'); rows.main.price.textContent=T.na; if(m) missing.push(m.name); }
      // alapozó
      var pr=data.primer, needP=A*(data.primerRate||0.15);
      var cP=pr?best(needP,packs(pr.packs)):null;
      rows.primer.detail.textContent=kgTxt(needP)+(cP?' · '+comboTxt(cP):'');
      if(cP){ rows.primer.el.classList.remove('is-na'); rows.primer.price.textContent=money(cP.cost); sum+=cP.cost; cP.items.forEach(function(it){ lines.push({id:it.p.id,quantity:it.q}); }); }
      else { rows.primer.el.classList.add('is-na'); rows.primer.price.textContent=T.na; if(pr) missing.push(pr.name); }
      // fedőréteg
      var co=pro?data.coatPro:data.coat, needC=A*(data.coatRate||0.3);
      if(coatName&&co) coatName.textContent=co.name.replace(/^VIRANIX\s+/,'');
      var cC=co?best(needC,packs(co.packs)):null;
      rows.coat.detail.textContent=kgTxt(needC)+(cC?' · '+comboTxt(cC):'');
      if(cC){ rows.coat.el.classList.remove('is-na'); rows.coat.price.textContent=money(cC.cost); sum+=cC.cost; cC.items.forEach(function(it){ lines.push({id:it.p.id,quantity:it.q}); }); }
      else { rows.coat.el.classList.add('is-na'); rows.coat.price.textContent=T.na; if(co) missing.push(co.name); }
      total.textContent=money(sum);
      plan={lines:lines, missing:missing};
      btn.disabled=!lines.length;
      btn.textContent=missing.length?T.partial:(btn.getAttribute('data-label')||emptyBtn);
      status.textContent='';
      if(a>200) setMsg(T.big,'is-info'); else setMsg('');
    }
    uses.forEach(function(b){ b.addEventListener('click',function(){ uses.forEach(function(x){ x.setAttribute('aria-pressed', x===b?'true':'false'); }); update(); }); });
    if(area) area.addEventListener('input',function(){ update(false); });
    if(extra) extra.addEventListener('change',function(){ update(); });
    if(range) range.addEventListener('input',function(){ area.value=range.value; update(true); });
    if(btn) btn.addEventListener('click',function(){
      if(!plan||!plan.lines.length) return;
      btn.disabled=true; var prev=btn.textContent; btn.textContent=T.adding;
      fetch(root.getAttribute('data-add-url'),{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:plan.lines})})
        .then(function(r){ if(!r.ok) throw new Error(String(r.status)); return r.json(); })
        .then(function(){
          window.location.href=root.getAttribute('data-cart-url');
        })
        .catch(function(){ btn.disabled=false; btn.textContent=prev; status.textContent=T.err; });
    });
    update();
  }
  function all(){ Array.prototype.forEach.call(document.querySelectorAll('[data-vx-sys]'),init); }
  if(document.readyState!=='loading') all(); else document.addEventListener('DOMContentLoaded',all);
  document.addEventListener('shopify:section:load',all);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vx-calculator"] && !Shopify.designMode) return;
  try {
    
(function(){
  function fmtNum(n,d){ return n.toLocaleString('hu-HU',{minimumFractionDigits:d,maximumFractionDigits:d}); }
  function init(root){
    if(root.getAttribute('data-vx-ready')) return;
    root.setAttribute('data-vx-ready','1');
    function attr(n){ return root.getAttribute(n)||''; }
    function fnum(n){ var v=parseFloat(attr(n)); return isNaN(v)?0:v; }
    var mode=attr('data-mode')||'area', active=attr('data-start')||'surface';
    var cmin=fnum('data-min'), cmax=fnum('data-max'), perUnit=fnum('data-per-cm'), tunit=attr('data-unit-t')||'cm';
    var tmin=fnum('data-t-min'), layerMax=fnum('data-layer-max'), totalMax=fnum('data-total-max'), density=fnum('data-density');
    var pack=fnum('data-pack')||1, unit=attr('data-unit')||'db', price=parseInt(attr('data-price'),10)||0, cur=attr('data-currency')||'HUF';
    var q=function(s){ return root.querySelector(s); };
    var area=q('[data-vx-area]'), range=q('[data-vx-range]'), thick=q('[data-vx-thick]');
    var hd=q('[data-vx-hd]'), rd=q('[data-vx-rd]'), hh=q('[data-vx-hh]'), hn=q('[data-vx-hn]');
    var msg=q('[data-vx-msg]'), kg=q('[data-vx-kg]'), packs=q('[data-vx-packs]'), cost=q('[data-vx-cost]');
    var qty=q('[data-vx-qty]'), btn=q('[data-vx-btn]'), btnText=q('[data-vx-btn-text]')||btn;
    var tabs=Array.prototype.slice.call(root.querySelectorAll('[data-vx-tab]'));
    var panels=Array.prototype.slice.call(root.querySelectorAll('[data-vx-panel]'));
    var surfaceEmpty=attr('data-surface-empty')||(msg?msg.textContent:''), holesEmpty=attr('data-holes-empty')||surfaceEmpty;
    var emptyBtn=btnText?btnText.textContent:'';
    var packsData=[], combo=null;
    try{ packsData=JSON.parse(attr('data-packs')||'[]'); }catch(e){ packsData=[]; }
    packsData=packsData.map(function(v){ return {id:v.id, kg:parseFloat(String(v.t).replace(',', '.')), price:v.p, a:v.a}; })
      .filter(function(v){ return v.a && v.kg>0; }).sort(function(x,y){ return y.kg-x.kg; });
    var multi=packsData.length>0;
    function bestCombo(need){
      var best=null;
      function rec(i,rem,chosen,cost,count){
        var p=packsData[i];
        if(i===packsData.length-1){
          var k=rem>0?Math.ceil(rem/p.kg-1e-9):0, c=cost+k*p.price, n=count+k;
          if(!best||c<best.cost||(c===best.cost&&n<best.count)) best={cost:c,count:n,items:k?chosen.concat([{p:p,q:k}]):chosen};
          return;
        }
        for(var k=Math.ceil(rem/p.kg-1e-9);k>=0;k--){
          rec(i+1,Math.max(0,rem-k*p.kg),k?chosen.concat([{p:p,q:k}]):chosen,cost+k*p.price,count+k);
        }
      }
      rec(0,need,[],0,0);
      return best;
    }
    function money(cents){ try{ return new Intl.NumberFormat('hu-HU',{style:'currency',currency:cur,maximumFractionDigits:0}).format(cents/100); }catch(e){ return fmtNum(cents/100,0)+' '+cur; } }
    function num(el){ if(!el) return 0; var v=parseFloat((el.value||'').replace(',', '.').replace(/[^0-9.]/g,'')); return isNaN(v)?0:v; }
    function setMsg(t,cls){ if(!msg) return; msg.textContent=t; msg.classList.remove('is-error','is-info'); if(cls) msg.classList.add(cls); }
    function reset(){ combo=null; kg.textContent='\u2013'; packs.textContent='\u2013'; cost.textContent='\u2013'; if(btn){ btn.disabled=true; btnText.textContent=emptyBtn; } }
    function show(kgv,digits){
      if(multi){
        combo=bestCombo(kgv);
        kg.textContent=fmtNum(kgv,digits)+' kg';
        packs.textContent=combo.items.map(function(it){ return it.q+' \u00d7 '+fmtNum(it.p.kg,it.p.kg%1?1:0)+' kg'; }).join(' + ');
        cost.textContent=money(combo.cost);
        if(btn){ btn.disabled=false; btnText.textContent=combo.count+' '+unit+' kos\u00e1rba'; }
        return;
      }
      var n=Math.max(1,Math.ceil(kgv/pack));
      kg.textContent=fmtNum(kgv,digits)+' kg';
      packs.textContent=n+' '+unit;
      cost.textContent=price?money(n*price):'\u2013';
      if(qty) qty.value=String(n);
      if(btn){ btn.disabled=false; btnText.textContent=n+' '+unit+' kosárba'; }
    }
    function update(fromRange){
      if(active==='holes'){
        var D=num(hd), d=num(rd), h=num(hh), n=Math.round(num(hn));
        if(!(D>0&&h>0&&n>0)){ reset(); setMsg(holesEmpty); return; }
        if(d>=D){ reset(); setMsg('A furat átmérője legyen nagyobb a betonacélénál.','is-error'); return; }
        var cm3=Math.PI/4*(D*D-d*d)*h/1000;
        var g=cm3*density;
        setMsg(n+' furat, furatonként kb. '+fmtNum(g,0)+' g habarccsal (veszteség nélkül).');
        show(g*n/1000, g*n<10000?2:1);
        return;
      }
      var a=num(area);
      if(!fromRange&&range&&a>0){ range.value=String(Math.min(parseFloat(range.max),Math.max(parseFloat(range.min),a))); }
      if(a<=0){ reset(); setMsg(surfaceEmpty); return; }
      if(mode==='thickness'||mode==='dual'){
        var t=num(thick);
        if(t<=0){ reset(); setMsg(surfaceEmpty); return; }
        if(tmin&&t<tmin){ reset(); setMsg('Legalább '+fmtNum(tmin,tmin%1?1:0)+' '+tunit+' rétegvastagság szükséges.','is-error'); return; }
        if(totalMax&&t>totalMax){ reset(); setMsg('Összesen legfeljebb '+fmtNum(totalMax,0)+' '+tunit+' vihető fel. Ennél vastagabb javításhoz kérj tanácsot.','is-error'); return; }
        if(layerMax&&layerMax<totalMax&&t>layerMax){ setMsg(fmtNum(layerMax,0)+' '+tunit+' felett két rétegben dolgozz: a második réteg csak az első megszilárdulása után jöhet.','is-info'); }
        else { setMsg('Számítás '+fmtNum(a,a%1?1:0)+' m² és '+fmtNum(t,t%1?1:0)+' '+tunit+' rétegvastagság alapján.'); }
        show(a*t*perUnit,1);
        return;
      }
      if(a>5000){ setMsg('Ekkora felülethez kérj egyedi ajánlatot lent az oldalon.','is-error'); }
      else { setMsg('Számítás '+fmtNum(a,a%1?1:0)+' m²-re.'); }
      var kmin=a*cmin, kmax=a*cmax;
      show(kmax,1);
      kg.textContent=fmtNum(kmin,1)+'\u2013'+fmtNum(kmax,1)+' kg';
    }
    function setTab(name){
      active=name;
      tabs.forEach(function(t){ t.setAttribute('aria-selected', t.getAttribute('data-vx-tab')===name?'true':'false'); });
      panels.forEach(function(p){ p.hidden = p.getAttribute('data-vx-panel')!==name; });
      update(false);
    }
    tabs.forEach(function(t){ t.addEventListener('click',function(){ setTab(t.getAttribute('data-vx-tab')); }); });
    [area,thick,hd,rd,hh,hn].forEach(function(el){ if(el) el.addEventListener('input',function(){ update(false); }); });
    if(range) range.addEventListener('input',function(){ area.value=range.value; update(true); });
    var vsel=q('[data-vx-variant]'), vid=q('[data-vx-id]');
    if(vsel&&vid){ vsel.addEventListener('change',function(){ vid.value=vsel.value; var o=vsel.options[vsel.selectedIndex]; price=parseInt(o.getAttribute('data-price'),10)||price; update(false); }); }
    var form=q('[data-vx-form]');
    if(form&&multi){
      form.addEventListener('submit',function(e){
        e.preventDefault();
        if(!combo||!btn) return;
        btn.disabled=true;
        var items=combo.items.map(function(it){ return {id:it.p.id, quantity:it.q}; });
        fetch((attr('data-add-url')||'/cart/add')+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
          .then(function(r){ if(!r.ok) throw new Error('cart'); window.location.href=attr('data-cart-url')||'/cart'; })
          .catch(function(){ btn.disabled=false; setMsg('Nem sikerült kosárba tenni, próbáld újra.','is-error'); });
      });
    }
    if(active==='holes') update(false);
  }
  function all(){ Array.prototype.forEach.call(document.querySelectorAll('[data-vx-calc]'),init); }
  if(document.readyState!=='loading') all(); else document.addEventListener('DOMContentLoaded',all);
  document.addEventListener('shopify:section:load',all);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vx-compare"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(b){ if(b.getAttribute('data-vx-ready')) return; b.setAttribute('data-vx-ready','1'); var r=b.querySelector('[data-vx-range]'); if(!r) return; function u(){ b.style.setProperty('--pos', r.value+'%'); } r.addEventListener('input',u); u(); }
  function all(){ Array.prototype.forEach.call(document.querySelectorAll('[data-vx-compare]'),init); }
  if(document.readyState!=='loading') all(); else document.addEventListener('DOMContentLoaded',all);
  document.addEventListener('shopify:section:load',all);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vx-crystal-explainer"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.getAttribute('data-vx-ready')) return;
    root.setAttribute('data-vx-ready','1');
    var fig=root.querySelector('[data-vx-fig]');
    var btns=Array.prototype.slice.call(root.querySelectorAll('[data-vx-stage]'));
    var cap=root.querySelector('[data-vx-caption]');
    if(!fig||!btns.length) return;
    var touched=false, timers=[];
    function set(n){
      fig.setAttribute('data-stage',String(n));
      btns.forEach(function(b){ b.setAttribute('aria-pressed', b.getAttribute('data-vx-stage')===String(n)?'true':'false'); });
      var active=btns[n-1];
      if(cap&&active){ var t=active.querySelector('.vx-ex__stage-title'); cap.textContent=t?t.textContent:''; }
    }
    btns.forEach(function(b){
      b.addEventListener('click',function(){ touched=true; timers.forEach(clearTimeout); set(parseInt(b.getAttribute('data-vx-stage'),10)); });
    });
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(!reduce&&'IntersectionObserver' in window&&btns.length>1){
      var io=new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if(!e.isIntersecting) return;
          io.disconnect();
          if(touched) return;
          for(var i=2;i<=btns.length;i++){ (function(n){ timers.push(setTimeout(function(){ if(!touched) set(n); },(n-1)*1700)); })(i); }
        });
      },{threshold:0.55});
      io.observe(fig);
    }
  }
  function all(){ Array.prototype.forEach.call(document.querySelectorAll('[data-vx-ex]'),init); }
  if(document.readyState!=='loading') all(); else document.addEventListener('DOMContentLoaded',all);
  document.addEventListener('shopify:section:load',all);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vx-home-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  if(window.vxAutoVideo) return; window.vxAutoVideo=1;
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io=('IntersectionObserver' in window)?new IntersectionObserver(function(es){
    es.forEach(function(e){ var v=e.target; if(e.isIntersecting&&!reduce&&!v.getAttribute('data-vx-paused')){ var p=v.play(); if(p&&p.catch) p.catch(function(){}); } else { v.pause(); } });
  },{threshold:0.35}):null;
  function scan(){ Array.prototype.forEach.call(document.querySelectorAll('video.vx-auto:not([data-vx-seen])'),function(v){ v.setAttribute('data-vx-seen','1'); v.muted=true; if(io) io.observe(v); }); }
  if(document.readyState!=='loading') scan(); else document.addEventListener('DOMContentLoaded',scan);
  document.addEventListener('shopify:section:load',scan);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vx-process"] && !Shopify.designMode) return;
  try {
    
(function(){
  if(window.vxAutoVideo) return; window.vxAutoVideo=1;
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io=('IntersectionObserver' in window)?new IntersectionObserver(function(es){
    es.forEach(function(e){ var v=e.target; if(e.isIntersecting&&!reduce&&!v.getAttribute('data-vx-paused')){ var p=v.play(); if(p&&p.catch) p.catch(function(){}); } else { v.pause(); } });
  },{threshold:0.35}):null;
  function scan(){ Array.prototype.forEach.call(document.querySelectorAll('video.vx-auto:not([data-vx-seen])'),function(v){ v.setAttribute('data-vx-seen','1'); v.muted=true; if(io) io.observe(v); }); }
  if(document.readyState!=='loading') scan(); else document.addEventListener('DOMContentLoaded',scan);
  document.addEventListener('shopify:section:load',scan);
})();
(function(){
  function init(root){
    if(!root||root.getAttribute('data-vx-ps-ready')) return; root.setAttribute('data-vx-ps-ready','1');
    var tabs=root.querySelectorAll('[data-vx-tab]'); if(tabs.length<2) return;
    root.classList.add('vx-ps--js');
    function show(i){
      Array.prototype.forEach.call(tabs,function(t){ var on=t.getAttribute('data-vx-tab')===i; t.setAttribute('aria-selected',on?'true':'false'); t.tabIndex=on?0:-1; });
      Array.prototype.forEach.call(root.querySelectorAll('[data-vx-panel]'),function(p){ p.hidden=p.getAttribute('data-vx-panel')!==i; });
    }
    Array.prototype.forEach.call(tabs,function(t){
      t.addEventListener('click',function(){ show(t.getAttribute('data-vx-tab')); });
      t.addEventListener('keydown',function(e){ if(e.key==='ArrowRight'||e.key==='ArrowLeft'){ var n=t.getAttribute('data-vx-tab')==='1'?'2':'1'; show(n); root.querySelector('[data-vx-tab="'+n+'"]').focus(); e.preventDefault(); } });
    });
    show('1');
  }
  function scan(){ Array.prototype.forEach.call(document.querySelectorAll('[data-vx-ps]'),init); }
  if(document.readyState!=='loading') scan(); else document.addEventListener('DOMContentLoaded',scan);
  document.addEventListener('shopify:section:load',scan);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vx-reels"] && !Shopify.designMode) return;
  try {
    
(function(){
  if(window.vxAutoVideo) return; window.vxAutoVideo=1;
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io=('IntersectionObserver' in window)?new IntersectionObserver(function(es){
    es.forEach(function(e){ var v=e.target; if(e.isIntersecting&&!reduce&&!v.getAttribute('data-vx-paused')){ var p=v.play(); if(p&&p.catch) p.catch(function(){}); } else { v.pause(); } });
  },{threshold:0.35}):null;
  function scan(){ Array.prototype.forEach.call(document.querySelectorAll('video.vx-auto:not([data-vx-seen])'),function(v){ v.setAttribute('data-vx-seen','1'); v.muted=true; if(io) io.observe(v); }); }
  if(document.readyState!=='loading') scan(); else document.addEventListener('DOMContentLoaded',scan);
  document.addEventListener('shopify:section:load',scan);
})();
(function(){
  function init(root){
    if(root.getAttribute('data-vx-ready')) return; root.setAttribute('data-vx-ready','1');
    var t=root.querySelector('[data-vx-track]'); if(!t) return;
    function step(){ var c=t.querySelector('.vx-rl__item'); return c?c.getBoundingClientRect().width+12:300; }
    var p=root.querySelector('[data-vx-prev]'), n=root.querySelector('[data-vx-next]');
    if(p) p.addEventListener('click',function(){ t.scrollBy({left:-step(),behavior:'smooth'}); });
    if(n) n.addEventListener('click',function(){ t.scrollBy({left:step(),behavior:'smooth'}); });
    Array.prototype.forEach.call(t.querySelectorAll('video'),function(v){
      v.addEventListener('click',function(){ if(v.paused){ v.removeAttribute('data-vx-paused'); v.play(); } else { v.setAttribute('data-vx-paused','1'); v.pause(); } });
    });
  }
  function all(){ Array.prototype.forEach.call(document.querySelectorAll('[data-vx-reels]'),init); }
  if(document.readyState!=='loading') all(); else document.addEventListener('DOMContentLoaded',all);
  document.addEventListener('shopify:section:load',all);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vx-systems"] && !Shopify.designMode) return;
  try {
    
(function(){
  if(window.vxAutoVideo) return; window.vxAutoVideo=1;
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io=('IntersectionObserver' in window)?new IntersectionObserver(function(es){
    es.forEach(function(e){ var v=e.target; if(e.isIntersecting&&!reduce&&!v.getAttribute('data-vx-paused')){ var p=v.play(); if(p&&p.catch) p.catch(function(){}); } else { v.pause(); } });
  },{threshold:0.35}):null;
  function scan(){ Array.prototype.forEach.call(document.querySelectorAll('video.vx-auto:not([data-vx-seen])'),function(v){ v.setAttribute('data-vx-seen','1'); v.muted=true; if(io) io.observe(v); }); }
  if(document.readyState!=='loading') scan(); else document.addEventListener('DOMContentLoaded',scan);
  document.addEventListener('shopify:section:load',scan);
})();

  } catch(e) { console.error(e); }
})();
})();
